export default "__VITE_ASSET__BhqItgDj__"